import { render, staticRenderFns } from "./GeneralConfirmationModal.vue?vue&type=template&id=ca0388e2&scoped=true&"
import script from "./GeneralConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./GeneralConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./GeneralConfirmationModal.vue?vue&type=style&index=0&id=ca0388e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0388e2",
  null
  
)

export default component.exports